<div *transloco="let t; read: 'featured'" class="featured-container font-xs-semibold">
  <accredible-icon [icon]="'star'"> </accredible-icon>
  {{ t('featured') }}
</div>
